import script from "./ModelpageFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelpageFilter.vue?vue&type=script&setup=true&lang=js"

import "./ModelpageFilter.vue?vue&type=style&index=0&id=242be5ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242be5ff"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
